export default class {

    constructor( table, locale = 'en' ) {
        this.table = null
        let database = require('./../db/'+locale+'.json')
        let levels = table.split(".")

        for( let i = 0; i < levels.length; i++  ) {
            if( this.table ) {
                this.table = this.table[levels[i]]
            } else {
                this.table = database[levels[i]]
            }
        }

        return this
    }

    all() {
        return this.table;
    }

}